export enum BydStorageKeysEnum {
  TOKEN_KEY = 'token',
  REFRESH_TOKEN_KEY = 'refreshToken',
  AUTHORIZATION_KEY = 'Authorization',
}
